import { ContextActions, initialState } from "@src/utils/ContextActions";

class AppActions extends ContextActions {

    setStatistics = (value) => {
        this.setState((state) => {
            state.statistics = value;
        }, "SET_STATISTICS");
    }

    setLead = (value) => {
        this.setState((state) => {
            state.lead = value;
        }, "SET_LEAD");
    }

    updateLead = (value) => {
        this.setState((state) => {
            state.lead = { ...state.lead, ...value };
        }, "UPDATE_LEAD");
    }

    isLoading = (value) => {// Solo per il modal
        this.setState((state) => {
            state.isLoading = value;
        }, "SET_LOADING");
    }

    showThx = (value) => {// Solo per il modal
        this.setState((state) => {
            state.showThx = value;
        }, "SET_SHOW_THX");
    }

    resetAll = (value) => {
        this.setState((state) => {
            state.statistics = null;
            state.lead = null;
            state.isLoading = false;
            state.showThx = false;
        }, "RESET_ALL");
    }

}

export default AppActions